export default "__VITE_ASSET__CpPSM_W___"